module.exports = __webpack_public_path__ + "img/codingiconred.f34ae38a.svg";